module.exports = __webpack_public_path__ + "static/media/LogicWheel5_1_1.1ce0febd.png";